/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Pedal_Vpedal_Setup_TitleInputs */



/**
* | output |
* | --- |
* | "vPedal Browser API setup" |
*
* @param {Options_Pedal_Vpedal_Setup_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_pedal_vpedal_setup_title = /** @type {((inputs?: Options_Pedal_Vpedal_Setup_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Pedal_Vpedal_Setup_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("vPedal Browser API setup")
	if (locale === "de") return /** @type {LocalizedString} */ ("vPedal Browser API setup")
	if (locale === "it") return /** @type {LocalizedString} */ ("vPedal Browser API setup")
	if (locale === "ru") return /** @type {LocalizedString} */ ("vPedal Browser API setup")
	if (locale === "es") return /** @type {LocalizedString} */ ("vPedal Browser API setup")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("vPedal Browser API setup")
	if (locale === "ja") return /** @type {LocalizedString} */ ("vPedal Browser API setup")
	if (locale === "hi") return /** @type {LocalizedString} */ ("vPedal Browser API setup")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("vPedal Browser API setup")
	return /** @type {LocalizedString} */ ("vPedal Browser API setup")
});